export default __webpack_public_path__ + "static/media/Ellipse 6.c7c43005.png";